// v10/src/services/fuelService.js
//
// Servicios de combustible (A9). Wrapper del axios `api` que ya maneja JWT,
// refresh automático e impersonación de SuperAdmin.
//
// Tarea 1: solo se consumen `getTanks` y `getDashboard`.
// El resto queda definido para que la Tarea 2 (modales y movimientos) los use.

import api from './apiService';

const fuelService = {
  // ── Tanques ──────────────────────────────────────────────────────
  getTanks:     (params = {})   => api.get('/api/fuel-tanks', { params }),
  getTankById:  (id)            => api.get(`/api/fuel-tanks/${id}`),
  createTank:   (data)          => api.post('/api/fuel-tanks', data),
  updateTank:   (id, data)      => api.put(`/api/fuel-tanks/${id}`, data),
  deleteTank:   (id)            => api.delete(`/api/fuel-tanks/${id}`),
  getAlerts:    ()              => api.get('/api/fuel-tanks/alerts'),
  getDashboard: ()              => api.get('/api/fuel-tanks/dashboard'),

  // ── Movimientos (los usa la Tarea 2) ─────────────────────────────
  getMovements:           (params = {})   => api.get('/api/fuel-movements', { params }),
  getMovementById:        (id)            => api.get(`/api/fuel-movements/${id}`),
  createMovement:         (data)          => api.post('/api/fuel-movements', data),
  getMovementsByTank:     (tankId)        => api.get(`/api/fuel-movements/by-tank/${tankId}`),
  getMovementsByAircraft: (aircraftId)    => api.get(`/api/fuel-movements/by-aircraft/${aircraftId}`),
  getMovementsSummary:    (params = {})   => api.get('/api/fuel-movements/summary', { params }),
};

export default fuelService;
